import AirtableTable from "../AirtableTable";
import { FriendsOfDwfPartner } from "../models";
import { airtableFields, airtableTables } from "../schema";

export const partnerFieldIds = airtableFields.partners;

export class FriendsOfDwfPartnerTable extends AirtableTable<FriendsOfDwfPartner> {
  constructor(instance: any) {
    super(instance, airtableTables.partners);

    this.fields = [
      partnerFieldIds.name,
      partnerFieldIds.about,
      partnerFieldIds.logo,
      partnerFieldIds.link1,
      partnerFieldIds.link1Text,
      partnerFieldIds.link2,
      partnerFieldIds.link2Text,
      partnerFieldIds.link3,
      partnerFieldIds.link3Text,
      partnerFieldIds.interfacePage,
      partnerFieldIds.show,
    ];
  }

  getAll = () => {
    return this.list({
      sort: [
        {
          field: partnerFieldIds.name,
          direction: "asc",
        },
      ],
    });
  };
}
